import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const banner = {
  banners: (params) => {
    const url = api.banner.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createBanner: (payloads) => {
    const url = api.banner.create
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  getBannerDetail: (id) => {
    const url = api.banner.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateBanner: (id, payloads) => {
    const url = api.banner.detail(id)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteBanner: (id) => {
    const url = api.banner.detail(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  }
}

export default banner
